<template>
  <!-- TODO: Ensure we can pass in default values for non-text based inputs. -->
  <div
    :class="this.field.inline ? 'owal form inline field' : 'owal form field'">
    <!-- Select -->
    <owal-select-input
      v-if="field.type === 'select'"
      v-bind="this.field"
      :initial-value="initialValue"
      @change="emitChange"
    />

    <owal-checkbox-input
      v-else-if="field.type === 'checkbox'"
      v-bind="this.field"
      :initial-value="initialValue"
      @change="emitChange"
    />
    <owal-radio-input
      v-else-if="field.type === 'radio'"
      v-bind="this.field"
      :initial-value="initialValue"
      @change="emitChange"
    />
    <owal-file-input
      v-else-if="this.field.type === 'file'"
      v-bind="this.field"
      :initial-value="initialValue"
      @change="emitChange"
    />

    <!-- Text, number, url, etc based inputs. -->
    <owal-text-input
      v-else
      v-bind="this.field"
      :initial-value="initialValue"
      @change="emitChange"
    />
  </div>
</template>

<script>
import * as inputs from '../inputs'

export default {
  name: 'FormField',
  components: {
    ...inputs,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    tokenizers: {
      type: Array,
      required: false,
      default: function () {
        return []
      },
    },
    initialValue: {
      type: undefined,
      required: false,
    },
  },
  methods: {
    emitChange (payload) {
      const eventType = this.field.type === 'input' ? 'input' : 'change'
      // console.log(`Emitting '${eventType}' event for field with identifier '${this.field.identifier}'`)
      this.$emit(eventType, payload)
    },
  },
}
</script>

<style scoped>
.owal {
  font-family: 'Lato', 'Avenir';
}
</style>
